import React, { useState } from "react";
import cn from "classnames";
import { Modal } from "reactstrap";

import { RadioButton } from "../../../../RadioButton/RadioButton";
import { Icon } from "../../../../Icon/Icon";
import { DisplaySettingsFormik } from "../../lib/useDisplaySettingsForm";

import signature from "../../../../../../assets/images/RDX-signature.png";
import lume from "../../../../../../assets/images/RDX-lume.png";

export enum ThemeType {
  signature = "signature",
  nivo = "nivo",
}

const themes: { type: ThemeType; imgSrc: string }[] = [
  {
    type: ThemeType.signature,
    imgSrc: signature,
  },
  {
    type: ThemeType.nivo,
    imgSrc: lume,
  },
];

interface Props {
  formik: DisplaySettingsFormik;
  isBussinesOrPro?: boolean;
}

export const ThemeCard = ({ formik, isBussinesOrPro }: Props) => {
  const [zoomImage, setZoomImage] = useState<ThemeType | undefined>(undefined);

  return (
    <>
      {zoomImage && (
        <Modal
          isOpen={!!zoomImage}
          toggle={() => setZoomImage(undefined)}
          className="ThemeSettings--zoomedModal"
        >
          <img
            src={themes.find((theme) => theme.type === zoomImage)?.imgSrc}
            alt={zoomImage}
          />
        </Modal>
      )}
      <div className="ThemeSettings__ThemeCard">
        {themes.map(({ type, imgSrc }) => (
          <div
            className={cn("ThemeSettings__ThemeCard--content", {
              "ThemeSettings__ThemeCard--active":
                type === formik.values.main.layoutTheme.themeVersion,
              "ThemeSettings__ThemeCard--disabled":
                type === ThemeType.nivo && !isBussinesOrPro,
            })}
            key={type}
          >
            <span className="ThemeSettings__ThemeCard--title">
              {type === ThemeType.nivo ? "LUME" : type.toUpperCase()}
            </span>
            {type === ThemeType.nivo && !isBussinesOrPro && (
              <div className="SubscriptionStatus">
                <Icon icon="lock" />
                Upgrade plan
              </div>
            )}

            <img src={imgSrc} alt={type} onClick={() => setZoomImage(type)} />

            <RadioButton
              name="main.layoutTheme.themeVersion"
              title="Select"
              value={type}
              checked={type === formik.values.main.layoutTheme.themeVersion}
              onChange={(e) => {
                formik.setFieldValue(
                  "main.layoutTheme.useColorImage",
                  type === ThemeType.nivo ? true : false
                );

                formik.handleChange(e);
              }}
              hideTitle
            />
          </div>
        ))}
      </div>
    </>
  );
};
